"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = require("../datapoints");
var markAsJunkService_1 = require("owa-mail-store/lib/services/markAsJunkService");
var undoActions = require("owa-mail-undo");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_mail_actions_1 = require("owa-mail-actions");
/**
 * mark item as junk action
 * @param itemIds of the items to be marked as junk/not junk
 * @param isJunkValueToSet used to determine whether the item should be marked as junk
 * @param actionSource the action source where this action is triggered
 */
exports.default = legacy_1.action('markItemsJunkNotJunkBasedOnItemIds', datapoints_1.default.markItemsJunkNotJunkDatapoint)(function markItemsJunkNotJunkBasedOnItemIds(itemIds, isJunkValueToSet, actionSource, instrumentationContexts, markItemsJunkNotJunkStoreUpdate) {
    undoActions.clearLastUndoableAction();
    markAsJunkService_1.default(itemIds, isJunkValueToSet);
    markItemsJunkNotJunkStoreUpdate();
    if (isJunkValueToSet) {
        owa_mail_actions_1.userMailInteractionAction('MarkAsJunk', instrumentationContexts);
    }
});
//# sourceMappingURL=markItemsJunkNotJunkBasedOnItemIds.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/helpers/markItemsJunkNotJunkBasedOnItemIds.js
// module id = 3472
// module chunks = 62